import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import EngApp from './eng/EngApp';
import UpdateBanner from './eng/UpdateBanner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><EngApp /><UpdateBanner /></React.StrictMode>);
